export default {
    // --------Title--------
    warehouseLocation: '仓库位置',
    basicInformationForWarehouse: '仓库基本信息',
    preciseLocationInformation: '精确位置信息',
    storages: '存储',
    defineForAvailableStorageSections: '可用存储区段',
    segmentation: '分段',
    organizeLocationSections: '整理位置部分',

     // --------Drawer--------
     newRack: '添加货架',
     updateRack: '更新货架',
     normal: '正常',
     reserved: '已预留',
     rackName: '货架名称',
     sortNo: '排序号',
     newSlot: '添加槽位',
     updateSlot: '更新槽位',
     slotName: '槽位名称',
     sequence: '顺序',
     newZone: '添加区域',
     updateZone: '更新区域',

    // --------MUI--------
    racks: '货架',
    zones: '区域',
    rack: '货架',
    worker: '仓库员工',
    locationName: '仓库名称',
    personInChargeName: '负责人姓名',

};